import { useEffect, useState } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    const formSection = document.getElementById('cta-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/68da44784910ec479c1ebc41a6ec0454.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <img 
            src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/4ec2bf74607ae5a6da072028c7b40c06.png" 
            alt="The One Logo" 
            className="h-8 sm:h-10 w-auto"
          />
          <button 
            onClick={scrollToForm}
            className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg font-medium text-xs sm:text-sm transition-all whitespace-nowrap cursor-pointer ${isScrolled ? 'bg-teal-600 text-white hover:bg-teal-700' : 'bg-white text-gray-900 hover:bg-gray-100'}`}
          >
            Solicitar diagnóstico
          </button>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center w-full pt-20 sm:pt-0">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
          Marketing 360 para empresas que buscam crescimento previsível
        </h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-100 mb-6 sm:mb-10 max-w-3xl mx-auto leading-relaxed px-2">
          Estratégia, aquisição e conversão integradas para negócios que faturam acima de R$30 mil por mês.
        </p>
        <button 
          onClick={scrollToForm}
          className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
        >
          Solicitar diagnóstico estratégico
        </button>
        <p className="text-xs sm:text-sm text-gray-200 mt-4 sm:mt-6 px-4">
          Atendimento nacional • Vagas limitadas por projeto
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden sm:block absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
